import { NgModule } from '@angular/core'
import { EmailStatusFilterPipe } from './email-status-filter.pipe'
import { EmailTypeFilterPipe } from './email-type-filter.pipe';

import { StepTypePipe } from './steps/step-type.pipe';

import { StatusPipe as ProjectStatusPipe } from './projects/status.pipe';
import { StatusPipe as StepStatusPipe } from './steps/status.pipe';
import { BadgesTextColourPipe } from './badges-text-colour.pipe';

@NgModule({
    declarations: [EmailStatusFilterPipe, EmailTypeFilterPipe, ProjectStatusPipe,StepTypePipe, StepStatusPipe, BadgesTextColourPipe],
    imports: [],
    exports: [EmailStatusFilterPipe, EmailTypeFilterPipe,ProjectStatusPipe,StepTypePipe,StepStatusPipe,BadgesTextColourPipe],
})
export class PipesModule {}
